import { InfoIconBlue } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import palette from '@utils/theme/palette';

import { IconWrapper, InfoBoxWrapper, Span, TimeText } from './style';

type InfoBoxProps = React.PropsWithChildren<{
  message: React.ReactNode;
  content?: (msg: React.ReactNode) => React.ReactNode;
  fullWidthAt?: number;
  advancePayment?: boolean;
  width?: string;
  padding?: string;
  margin?: string;
  maxWidth?: string;
  disable?: boolean;
  hasReference?: boolean;
  promotionClub?: boolean;
  minHeight?: string;
  justifyContent?: string;
  chippin?: boolean;
}>;

const InfoBox = ({
  message,
  content = (msg) => <Span promotionClub={promotionClub}>{msg}</Span>,
  children,
  fullWidthAt = 500,
  advancePayment = false,
  width,
  padding,
  margin,
  maxWidth,
  disable,
  hasReference,
  promotionClub,
  minHeight,
  justifyContent,
  chippin,
}: InfoBoxProps) => {
  return (
    <InfoBoxWrapper
      justifyContent={justifyContent}
      fullWidthAt={fullWidthAt}
      advancePayment={advancePayment}
      width={width}
      padding={padding}
      margin={margin}
      style={{ maxWidth }}
      promotionClub={promotionClub}
      minHeight={minHeight}
    >
      {!disable ? (
        <>
          {hasReference ? (
            <IconWrapper>
              <CustomIcon icon={InfoIconBlue} fontSize={18} />
            </IconWrapper>
          ) : (
            <>
              {chippin ? null : (
                <CustomIcon
                  fill={promotionClub ? palette.persianRed : palette.clearBlue}
                  icon={InfoIconBlue}
                  width={16}
                  height={16}
                />
              )}
            </>
          )}
        </>
      ) : null}
      {content(message)}
      {chippin ? <TimeText>{children}</TimeText> : <> {children} </>}
    </InfoBoxWrapper>
  );
};

export default InfoBox;
